import { render, staticRenderFns } from "./feedbackForm.vue?vue&type=template&id=b41f8ffe&"
import script from "./feedbackForm.vue?vue&type=script&lang=js&"
export * from "./feedbackForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports